import { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';

import { getCurrentUser } from "../../utils/auth"

const AccountProfileDetails = (props) => {

  const currentUser = getCurrentUser()

  const [values, setValues] = useState({
    name: currentUser.name,
    email: currentUser.email,
  });

  return (
    <form
      autoComplete="off"
      noValidate
      {...props}
    >
      <Card>
        <CardHeader
          subheader={<>Ces informations ne sont pas modifiables.</>}
          title="Votre compte"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Votre nom"
                name="name"
                //onChange={handleChange}
                disabled
                value={values.name}
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Votre email"
                disabled
                name="email"
                //onChange={handleChange}
                value={values.email}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </CardContent>

        {/*
          <Divider />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              p: 2
            }}
          >
            <Button
              color="primary"
              variant="contained"
            >
              Save details
            </Button>
          </Box>
        */}
      </Card>
    </form>
  );
};

export default AccountProfileDetails;
